import * as types from './actionTypes'
import { smsService } from '../_services'
import { toast } from 'react-toastify'

toast.configure()

export function sendSMS(data) {
    return function(dispatch) {
        return smsService
            .sendSMS(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .then(res => {
                toast.success("Success", {
                    position: 'top-center',
                    // autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                })
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.SEND_SMS, payload: payload }
    }
    function failure(error) {
        return { type: types.SEND_SMS_FAILURE, error }
    }
}

export function statisticsSms(data) {
    return function(dispatch) {
        return smsService
            .statisticsSms(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.STATS_SMS, payload: payload }
    }
    function failure(error) {
        return { type: types.STATS_SMS_FAILURE, error }
    }
}
